module.exports = __webpack_public_path__ + "img/logo_1.95be4130.png";